import * as React from "react";
import "./styles.scss";
import { useContext } from "react";
import { PlayerCardSettingsContext } from "../../Contexts";
import { PlayersServices, SegmentationDetailServices } from "../../../../services/bedrock";
import PaginatedDropdown from "../../../../components/PaginatedDropdown";
import { CancelToken } from "axios";

interface PlayerCardFiltersProps {}

const PlayerCardFilters: React.FC<PlayerCardFiltersProps> = () => {
  const { PlayerCards, Templates, Themes } = useContext(PlayerCardSettingsContext);

  const loadPlayerData = async (page: number, search?: string, cancelToken?: CancelToken) => {
    const data = await PlayersServices.getPlayers({ search, page }, { cancelToken });
    const content = data.content.map(convertPlayerToDropdownItem);
    return { ...data, content };
  };

  const loadBranchData = async (page: number, searchQuery?: string, cancelToken?: CancelToken) => {
    const data = await SegmentationDetailServices.getSegmentationDetails(
      ["BRANCH"],
      searchQuery,
      page,
      25,
      cancelToken
    );
    const content = data.content.map(convertNamedObjectToDropdownItem);
    return { ...data, content };
  };

  const loadRegionData = async (page: number, searchQuery?: string, cancelToken?: CancelToken) => {
    const data = await SegmentationDetailServices.getSegmentationDetails(
      ["REGION"],
      searchQuery,
      page,
      25,
      cancelToken
    );
    const content = data.content.map(convertNamedObjectToDropdownItem);
    return { ...data, content };
  };

  const convertPlayerToDropdownItem = (item: any) => {
    return { key: item.id, text: item.fullName, value: item.id };
  };
  const convertNamedObjectToDropdownItem = (item: any) => ({ key: item.id, text: item.name, value: item.id });

  return (
    <div className="playerCardFilters">
      <PaginatedDropdown
        search
        onChange={(_e, data) =>
          PlayerCards.setFilter("playerId", Number.isFinite(data.value) ? (data.value as number) : undefined)
        }
        loadData={loadPlayerData}
        placeholder="Player"
        clearable
        value={PlayerCards.filters?.playerId}
      />
      <PaginatedDropdown
        search
        onChange={(_e, data) =>
          PlayerCards.setFilter("templateId", Number.isFinite(data.value) ? (data.value as number) : undefined)
        }
        loadData={Templates.loadTemplateDropdownOptions}
        placeholder="Template"
        clearable
        value={PlayerCards.filters?.templateId}
      />
      <PaginatedDropdown
        search
        onChange={(_e, data) =>
          PlayerCards.setFilter("themeId", Number.isFinite(data.value) ? (data.value as number) : undefined)
        }
        loadData={Themes.loadThemeDropdownOptions}
        placeholder="Theme"
        clearable
        value={PlayerCards.filters?.themeId}
      />
      <PaginatedDropdown
        search
        onChange={(_e, data) =>
          PlayerCards.setFilter("branchId", Number.isFinite(data.value) ? (data.value as number) : undefined)
        }
        loadData={loadBranchData}
        placeholder="Branch"
        clearable
        value={PlayerCards.filters?.branchId}
      />
      <PaginatedDropdown
        search
        onChange={(_e, data) =>
          PlayerCards.setFilter("regionId", Number.isFinite(data.value) ? (data.value as number) : undefined)
        }
        loadData={loadRegionData}
        placeholder="Region"
        clearable
        value={PlayerCards.filters?.regionId}
      />
    </div>
  );
};
export default PlayerCardFilters;
